export default __webpack_public_path__ + "static/screen_img768-15485066a1ebd8ce6606253cce28c412.png";